import { useState } from 'react';
import VoxeetSDK from '@voxeet/voxeet-web-sdk';
import { Select } from 'antd';

import { upload } from '../../../libs/utils';
import { useRoomStore } from '../../../stores/room';
import { useUserStore } from '../../../stores/user';
import { ReactComponent as SettingsIcon } from '../icons/settings.svg';
import { ReactComponent as ArrowIcon } from '../icons/arrow-left.svg';
import styles from './conference.module.css';
import { useNavigate } from 'react-router';

const VIEW_MODE = [
    {
        id: 'videos',
        label: 'Videos'
    },
    {
        id: 'presentation',
        label: 'Presentation'
    }
]

export function ConferenceRoom({
    onOpenSettings
}){
    const navigate = useNavigate();
    const { participants, id, name, spaceId } = useRoomStore();
    const { id: userId } = useUserStore();
    const [mode, setMode] = useState(VIEW_MODE[0].id);
    return <div className={styles.room}>
        <div className={styles.toolbar}>
            <button onClick={() => {
                navigate(`/spaces/${spaceId}`);
            }}  className={styles.back}>
                <ArrowIcon />
            </button>
            <h1>{name}</h1>
            <span style={{flex: "1 1 100%"}} />
            <div style={{ display: 'flex', alignItems: 'center', padding: '0 1rem' }}>
               <Select value={mode} onChange={value => {
                   setMode(value);
               }}>
                   {VIEW_MODE.map(v => <Select.Option value={v.id} key={v.id}>{v.label}</Select.Option>)}
                </Select> 
            </div>
            <button onClick={onOpenSettings}><SettingsIcon /></button>
        </div>
        <div className={styles.content}>
            <div className={`${styles.row} ${styles.top}`}>
                <div className={styles.seat} />
                <Seat />
                <Seat />
                <Seat />
                <div className={styles.seat} />
            </div>
            <div className={`${styles.row} ${styles.middle}`}>
                <Seat />
                <Table />
                <Seat />
            </div>
            <div className={`${styles.row} ${styles.bottom}`}>
                <div className={styles.seat} />
                <Seat />
                <Seat />
                <Seat />
                <div className={styles.seat} />
            </div>
        </div>
    </div>;
}

function Seat(){
    return <div className={styles.seat}>
        <div className={styles.chair}>
            <button className={styles.selectseat}>Select Seat</button>
        </div>
    </div>;
}

function Table({
    id
}){
    return <div className={styles.table}>
        <div className={styles.emptymessagehost}>
            <button>Choose a file<input type="file" onChange={async e => {
                const file = e.target.files[0];
                if(file.type === 'video/mp4'){
                    const uploaded = await upload(file, `room/${id}`);
                    VoxeetSDK.videoPresentation.start(uploaded.secure_url);
                }
                else{
                    if(file){
                        VoxeetSDK.filePresentation.convert(file);
                        VoxeetSDK.filePresentation.on('converted', e => {
                            console.log('CONVERTED', e);
                            VoxeetSDK.filePresentation.start(e);
                        });
                    }
                }
            }} /></button> to start presenting or <button onClick={() => {
                VoxeetSDK.conference.startScreenShare();
            }}>Share Your Screen</button>
        </div>
        <div className="underdevelopment">Under Development</div>
    </div>;
}